import React, { useState, useEffect, useContext } from 'react';
import {format} from "date-fns";

import * as net from "../../../lib/net";
import * as utils from "../../../assets/utils";

import Dt_Cal from "../../../lib/ui/dt_cal";
import Dd_BtnSel from "../../../lib/ui/dd_btnsel";
import Dd_Sel from "../../../lib/ui/dd_sel";
import Td_Sel from "../../../lib/ui/td_sel";

import Reg_RtRooms from "./rooms.js";
import Reg_RtEdit from "./rtedit.js";
import Reg_RtInit from "./rt_init.js";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Reg_Rt extends React.Component {
  constructor(props, context) {
    super(props);

      this.dt_fd = React.createRef();
      this.dt_td = React.createRef();

      this.store = props.store;

    this.state = {};
    this.state.avd = "";
    this.state.rta = [];
    this.state.kro = {};
    this.state.aa = [];
      this.state.cols = {};
      this.state.wnds = {};
    this.state.wnd_rooms = false;

      this.state.today = new Date();
      var dts = format(this.state.today, "yyyy-MM-dd");
      this.state.fdat = dts;
      this.state.tdat = dts;

    this.selitems = [
        {fkn: 'init_rt', text: 'INITIERA RUMSTYPER'},
        {fkn: 'refresh', text: 'UPPDATERA'}
    ];
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.rts();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
    tb_style() {
        var css = {};
        css.height = window.innerHeight - 275;
        css.overflow = "auto";
        return css;
    }
    th_style(id) {
        var css = {};
        css.cursor = "pointer";
        if(id == this.state.sortid) {
            if(this.state.sortdir) css.color = "#800";
            else css.color = "#080";
        }
        return css;
    }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }
    dt_fdat(e) {
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ fdat: dts });
    }
    dt_tdat(e) {
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ tdat: dts });
    }
    oneday(e) {
        //alert(JSON.stringify(e));
        //this.setState({ tdat: this.state.fdat });
        this.dt_td.current.updateDt(this.state.fdat);
    }
    addday(e) {
        //alert(JSON.stringify(e));
        //this.setState({ tdat: this.state.fdat });
        this.dt_fd.current.updateAdd();
        this.dt_td.current.updateAdd();
    }
    subday(e) {
        //alert(JSON.stringify(e));
        //this.setState({ tdat: this.state.fdat });
        this.dt_fd.current.updateSub();
        this.dt_td.current.updateSub();
    }

  rts() {
    var self = this;
    var prm = {};
    prm.req = "pms.rt.rt_date";
    prm.rstyp = "M";
    prm.fdat = this.state.fdat;
    prm.tdat = this.state.tdat;
    //prm.avd = this.state.avd;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({ rta: ret.rco }, function () {
            self.syncTb("rtTable");
        });
    })
    .catch(function(e) {
        var txt = JSON.stringify(e);
    });
  }

    rt_init() {
        var self = this;
        var wnds = {};
        wnds.rtinit = {};
        wnds.fdat = this.state.fdat;
        wnds.tdat = this.state.tdat;
        self.setState({wnds: wnds });
    }
  xrt_init() {
    var self = this;
    var prm = {};
    prm.req = "pms.rt.rt_init";
    prm.fdat = this.state.fdat;
    prm.tdat = this.state.tdat;
    //prm.avd = this.state.avd;

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        alert(JSON.stringify(ret));

        //self.setState({rta: ret.rco });
    })
    .catch(function(e) {
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
  xrt_ruminit() {
    var self = this;
    var prm = {};
    prm.req = "pms.rt.rt_gsb_init";
    prm.fdat = this.state.fdat;
    prm.tdat = this.state.tdat;
    //prm.avd = this.state.avd;

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        alert(JSON.stringify(ret));

        //self.setState({rta: ret.rco });
    })
    .catch(function(e) {
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
    syncTb(tb) {
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
            tdElements = tbel.getElementsByTagName('td');
        if(tdElements.length < 1 ) return;

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
                width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
    tb_sort(typ) {
        var self = this;
        //var rvs = self.state.rvs;
        var tha = self.state.tha;
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;

        if(sortid != typ) sortdir = 0;
        else {
            if(sortdir) sortdir = 0;
            else sortdir = 1;
        }

        if(typ) {
            if(sortdir) tha.sort((a,b) => (a[typ] < b[typ]) ? 1 : ((b[typ] < a[typ]) ? -1 : 0));
            else tha.sort((a,b) => (a[typ] > b[typ]) ? 1 : ((b[typ] > a[typ]) ? -1 : 0));
        }
        self.setState({ tha: tha, sortid: typ, sortdir: sortdir });
    }
    th_icon(typ) {
        var cls = "";
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;
        if(sortid == typ)
        {
            if(sortdir) cls = "fa fa-caret-up";
            else cls = "fa fa-caret-down";
        }
        return cls;
    }
    show_rooms() {
        var self = this;
        var wnds = {};
        wnds.wnd_rooms = {};
        wnds.rta = this.state.rta;
        self.setState({wnds: wnds });
    }
    rt_edit(row) {
        var self = this;
        var wnds = {};
        wnds.wnd_rt = {};
        wnds.rta = this.state.rta;
        wnds.rto = row;
        self.setState({wnds: wnds });
    }

  sel_fkn(sel) {
    //alert(JSON.stringify(fkn));
      if(sel.fkn == "init_rt") {
          this.rt_init();
      }
  }

  render() {
    return (
    <div className="web-app">
    <div className="flex-row flex-space-between">
        <div className="flex-row flex">
        <Dd_BtnSel text="FUNKTIONER" cls="w150" items={ this.selitems } getValue={(e)=> this.sel_fkn(e)} />
        </div>
        <div className="flex-row">
            <div className="dt-btn-01" onClick={() => this.subday() } ><FontAwesomeIcon icon="minus" size="1x" /></div>
            <Dt_Cal dts={ this.state.fdat } rp="1" ref={this.dt_fd} getValue={(e)=> this.dt_fdat(e)} />
            <div className="dt-btn-01" onClick={() => this.oneday() } >1</div>
            <Dt_Cal dts={ this.state.tdat } rp="1" ref={this.dt_td} getValue={(e)=> this.dt_tdat(e)} />
            <div className="dt-btn-01" onClick={() => this.addday() } ><FontAwesomeIcon icon="plus" size="1x" /></div>
       </div>
        <div className="flex-row flex-end flex">

            <button className="btn btn-hw-green w150" onClick={() => this.show_rooms() } aria-label="System" >
                VISA RUM
            </button>
        <button className="btn btn-hw-blue w150" onClick={() => this.rts() } aria-label="System" >
            UPPDATERA
        </button>
        <div className="flex-row">
            <Dd_Sel items={ this.selitems } getValue={(e)=> this.sel_fkn(e)} />
        </div>
    </div>
    </div>
    <div className="divider_orange"></div>

        <div id="rtTable" className="web-col">
            <table className="table table-bordered table-hover tb " style={{marginBottom: "0px"}}>
                <thead>
                <tr>
                    <th style={ this.th_style("r1typ") } onClick={() => this.tb_sort("r1typ") }>Typ <i className={ this.th_icon("r1typ") }></i></th>
                    <th style={ this.th_style("r1sort") } onClick={() => this.tb_sort("r1sort") }>Sort <i className={ this.th_icon("r1sort") }></i></th>
                    <th style={ this.th_style("r1tillgr") } onClick={() => this.tb_sort("r1tillgr") }>Antal <i className={ this.th_icon("r1tillgr") }></i></th>
                    <th style={ this.th_style("r1closed") } onClick={() => this.tb_sort("r1closed") }>Stängda <i className={ this.th_icon("r1closed") }></i></th>
                    <th style={ this.th_style("r1max") } onClick={() => this.tb_sort("r1max") }>Max <i className={ this.th_icon("r1max") }></i></th>
                    <th style={ this.th_style("r1lediga") } onClick={() => this.tb_sort("r1lediga") }>Ledigt <i className={ this.th_icon("r1lediga") }></i></th>
                    <th style={ this.th_style("status") } onClick={() => this.tb_sort("status") }>Status <i className={ this.th_icon("status") }></i></th>
                    <th></th>
                </tr>
                </thead>
            </table>
            <div className="tb-cdi" style={ this.tb_style() }>
                <table className="table table-bordered table-hover tb">
                    <tbody>
                    { this.state.rta.map((row, key) =>
                        <tr key={key} onDoubleClick={() => this.rt_edit(row) }>
                            <td className="px-2">{ utils.toLang( row.r1typ ) }</td>
                            <td className="text-center">{ row.r1sort }</td>
                            <td className="text-center">{ utils.toNum( row.r1tillgr ) }</td>
                            <td className="text-center">{ row.r1closed }</td>
                            <td className="text-center">{ utils.toNum( row.r1max ) }</td>
                            <td className="text-center">{ utils.toNum( row.r1lediga ) }</td>
                            <td className="text-center">{ utils.toLang( row.status ) }</td>
                            <td>
                                <Td_Sel items={ this.selitems } getValue={(e)=> this.sel_row_fkn(row, e)} />
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </div>
        { this.state.wnds.wnd_rooms ? <Reg_RtRooms wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.wnds.wnd_rt ? <Reg_RtEdit wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.wnds.rtinit ? <Reg_RtInit wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
   </div>
  );
    }
}
export default Reg_Rt;
